import { put, call, fork, join, delay } from 'redux-saga/effects'

import * as types from '../actions/actionTypes'
import { getSellerHistoriesSuccessAction } from '../actions/sellerHistoryAction'
import { setSnackbarErrorAction } from '../actions/snackbarActions'
import * as api from '../api'
import { getErrorMessage } from '../domain/Errno'
import { FETCH_LANDING_STATES } from '../reducers/landingReducer'
import { attemptRefreshToken } from './userSaga'

export function* getSellerHistoriesSaga({ payload: timestampTz }) {
  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)

    yield delay(100)

    const {
      data: { items },
    } = yield call(api.requestGetSellerHistories, timestampTz)
    if (items?.length > 0) {
      yield put({
        type: types.SET_LANDING_FETCH_STATE,
        payload: FETCH_LANDING_STATES.FETCHED_IS_SELLER,
      })
    }
    yield put(getSellerHistoriesSuccessAction(items, !timestampTz))
  } catch (err) {
    console.error('getSellerHistoriesSaga', err)
    const message = getErrorMessage(err)
    yield put({ type: types.GET_SELLER_HISTORIES_ERROR })
    yield put(setSnackbarErrorAction(message))
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}

export function* getSellerHistoryDetailSaga({ payload }) {
  const { itemId } = payload

  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)

    const { timestampTz } = payload
    const res = yield call(
      api.requestGetSellerHistoryDetail,
      itemId,
      timestampTz,
    )
    yield put({
      type: types.GET_SELLER_HISTORY_DETAIL_SUCCESS,
      payload: {
        itemId,
        data: res.data,
        replace: !timestampTz,
      },
    })
  } catch (err) {
    console.error('getSellerHistoryDetailSaga', err)
    const message = getErrorMessage(err)
    yield put({
      type: types.GET_SELLER_HISTORY_DETAIL_ERROR,
      payload: { itemId },
    })
    yield put(setSnackbarErrorAction(message))
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}

export function* getInstalmentHistoriesSaga({ payload: periodId }) {
  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)

    const res = yield call(api.requestGetInstalmentHistories, periodId)
    yield put({
      type: types.GET_INSTALMENT_HISTORIES_SUCCESS,
      payload: {
        periodId,
        data: res.data,
      },
    })
  } catch (err) {
    console.error('getInstalmentHistoriesSaga', err)
    const message = getErrorMessage(err)
    yield put({
      type: types.GET_INSTALMENT_HISTORIES_ERROR,
      payload: { periodId },
    })
    yield put(setSnackbarErrorAction(message))
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}
